module.exports = __webpack_public_path__ + "assets/upgrade-modal-icon.c94a00ab.svg";